import React, { useState } from 'react'
import styled from 'styled-components'
import { format } from 'date-fns-tz'
import { useHistory } from 'react-router-dom'

import { PointHow } from './PointHow'
import { PointExpireHow } from './PointExpireHow'

import coinSrc from 'images/point_coin.png'
import questionSrc from 'images/point_question.png'
import arrowSrc from 'images/arrow_right.png'

export function PointStatistic({ ownedPoint, toBeExpiredPoint }) {
  const thisMonth = format(new Date(), 'MM', 'Asia/Seoul')

  const [isPointHowOpened, setIsPointHowOpened] = useState(false)
  const [isPointExpireHowOpened, setIsPointExpireHowOpened] = useState(false)

  const history = useHistory()

  return (
    <PointStat>
      <PointStatUp>
        <OwnedPointTitle>보유 포인트</OwnedPointTitle>

        <OwnedPointWrapper>
          <OwnedPointCenterWrapper>
            <CoinImgWrapper>
              <CoinImg src={coinSrc} />
            </CoinImgWrapper>
            <Point>
              {ownedPoint !== undefined ? `${new Intl.NumberFormat().format(ownedPoint)}P` : ''}
            </Point>
          </OwnedPointCenterWrapper>

          <Tooltip>
            <QuestionImgWrapper onClick={() => setIsPointHowOpened((prev) => !prev)}>
              <QuestionImg src={questionSrc} />
            </QuestionImgWrapper>

            <PointHow isOpened={isPointHowOpened} onClose={() => setIsPointHowOpened(false)} />
          </Tooltip>
        </OwnedPointWrapper>
      </PointStatUp>

      <PointStatDivider />

      <PointStatBottom>
        <ToBeExpiredPointWrapper>
          <ToBeExpiredPointKey>{`${thisMonth}월 소멸 예정`}</ToBeExpiredPointKey>
          <ToBeExpiredPointValue>
            {toBeExpiredPoint !== undefined
              ? `${new Intl.NumberFormat().format(toBeExpiredPoint)}P`
              : ''}
          </ToBeExpiredPointValue>

          <Tooltip2>
            <QuestionImgWrapper2 onClick={() => setIsPointExpireHowOpened((prev) => !prev)}>
              <QuestionImg2 src={questionSrc} />
            </QuestionImgWrapper2>

            <PointExpireHow
              isOpened={isPointExpireHowOpened}
              onClose={() => setIsPointExpireHowOpened(false)}
            />
          </Tooltip2>
        </ToBeExpiredPointWrapper>

        <PointPolicyWrapper onClick={() => history.push('/mypage/point/policy')}>
          <PointPolicyText>포인트 정책 안내</PointPolicyText>
          <ArrowImgWrapper>
            <ArrowImg src={arrowSrc} />
          </ArrowImgWrapper>
        </PointPolicyWrapper>
      </PointStatBottom>
    </PointStat>
  )
}

const PointStat = styled.div`
  margin-top: calc(100vw * (9 / 375));
  margin-bottom: calc(100vw * (11 / 375));
  background-color: #fff8e3;
  border-radius: calc(100vw * (17 / 375));
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: relative;
  z-index: 1;
`

const PointStatUp = styled.div`
  padding: 0 calc(100vw * (18 / 375));
`

const OwnedPointTitle = styled.div`
  margin-top: calc(100vw * (22 / 375));
  font-weight: 500;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (19 / 375));
  color: #4e4e4e;
`

const OwnedPointWrapper = styled.div`
  margin-top: calc(100vw * (18 / 375));
  margin-bottom: calc(100vw * (23 / 375));
  display: flex;
  flex-direction: row;
  align-items: start;
`

const OwnedPointCenterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const CoinImgWrapper = styled.div`
  width: calc(100vw * (34 / 375));
  height: calc(100vw * (35 / 375));
  margin-right: calc(100vw * (8 / 375));
`

const CoinImg = styled.img`
  width: 100%;
  height: 100%;
`

const Point = styled.div`
  font-weight: 700;
  font-size: calc(100vw * (26 / 375));
  line-height: calc(100vw * (31 / 375));
  letter-spacing: 0.005em;
  color: #121212;
`

const Tooltip = styled.div`
  position: relative;
`

const QuestionImgWrapper = styled.div`
  width: calc(100vw * (16 / 375));
  height: calc(100vw * (16 / 375));
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: calc(100vw * (3 / 375));
  margin-top: calc(100vw * (5 / 375));
`

const QuestionImg = styled.img`
  width: calc(100vw * (14 / 375));
  height: calc(100vw * (14 / 375));
`

const PointStatDivider = styled.div`
  background-color: #ebd79b;
  height: 1px;
  margin: 0 calc(100vw * (18 / 375));
`

const PointStatBottom = styled.div`
  padding: 0 calc(100vw * (18 / 375));
  margin-top: calc(100vw * (20 / 375));
  margin-bottom: calc(100vw * (20 / 375));
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const ToBeExpiredPointWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const ToBeExpiredPointKey = styled.div`
  font-weight: 500;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (19 / 375));
  color: #4e4e4e;
  margin-right: calc(100vw * (5 / 375));
`

const ToBeExpiredPointValue = styled.div`
  font-weight: 700;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (19 / 375));
  color: #ff6b00;
  letter-spacing: 0.02em;
`

const Tooltip2 = styled.div`
  position: relative;
`

const QuestionImgWrapper2 = styled.div`
  width: calc(100vw * (16 / 375));
  height: calc(100vw * (16 / 375));
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: calc(100vw * (3 / 375));
  margin-top: calc(100vw * (-5 / 375));
`

const QuestionImg2 = styled.img`
  width: calc(100vw * (14 / 375));
  height: calc(100vw * (14 / 375));
`

const PointPolicyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const PointPolicyText = styled.div`
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (17 / 375));
  color: #7f7f7f;
`

const ArrowImgWrapper = styled.div`
  width: calc(100vw * (5 / 375));
  height: calc(100vw * (8 / 375));
  margin-left: calc(100vw * (6 / 375));
`

const ArrowImg = styled.img`
  width: 100%;
  height: 100%;
`
